<template>
    <div
        v-click-outside="hideMenu"
        v-esc="hideMenu"
        class="DatatableMenuOptions"
    >
        <a
            class="DatatableMenuOptions--btn"
            @click.prevent="toggleMenu"
        >
            <slot>
                <i class="fa fa-cogs"></i>
            </slot>
        </a>
        <ul
            v-if="showMenu"
            class="DatatableMenuOptions--menu"
        >
            <li>
                <label>{{ transChoice('app.setting', 2).titleCase() }}</label>
            </li>
            <li class="DatatableMenuOptions--divider"></li>
            <li>
                <label
                    for="setting-state"
                    class="DatatableMenuOptions--checkbox"
                >
                    <input
                        id="setting-state"
                        v-model="currentSettings.saveState"
                        name="setting-state"
                        type="checkbox"
                    >
                    {{ trans('app.datatable.settings.save_search_filters') }}
                </label>
            </li>

            <li>
                <label>Columns to show:</label>
            </li>
            <li class="DatatableMenuOptions--divider"></li>
            <li
                v-for="column in columns"
                :key="`column-${column.name}`"
            >
                <label
                    :for="`column-${column.name}`"
                    class="DatatableMenuOptions--checkbox"
                >
                    <input
                        :id="`column-${column.name}`"
                        v-model="currentColumnsToShow"
                        :name="`column[${column.name}]`"
                        :value="column.name"
                        type="checkbox"
                    >
                    {{ column.title }}
                </label>
            </li>

            <template v-if="Object.keys(realGroupByOptions).length">
                <li>
                    <label>Group by:</label>
                </li>
                <li class="DatatableMenuOptions--divider"></li>
                <input-radio-group
                    id="group-by"
                    v-model="currentGroupBy"
                    :options="realGroupByOptions"
                    name="group-by"
                ></input-radio-group>
            </template>
        </ul>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
    directives: {
        ClickOutside,
    },

    props: {
        columns: {
            type: Array,
            default: null,
        },

        columnsToShow: {
            type: Array,
            default: () => [],
        },

        settings: {
            type: Object,
            required: true,
        },
        groupBy: {
            type: String,
            default: null,
        },
        groupByOptions: {
            type: Object,
            default: () => {},
        },
    },

    data () {
        return {
            showMenu: false,
            currentColumnsToShow: this.columnsToShow,
            currentSettings: this.settings,
            currentGroupBy: this.groupBy,
        };
    },

    computed: {
        realGroupByOptions () {
            if (! this.groupByOptions || Object.keys(this.groupByOptions).length) {
                return {};
            }

            const options = Object.keys(this.groupByOptions).map(value => ({
                value,
                text: this.groupByOptions[value],
            }));

            options.unshift({
                value: null,
                text: this.trans('app.default').titleCase(),
            });

            return options;
        },
    },

    watch: {
        columnsToShow (columnsToShow) {
            this.currentColumnsToShow = columnsToShow;
        },

        settings (settings) {
            this.currentSettings = settings;
        },

        groupBy (groupBy) {
            this.currentGroupBy = groupBy;
        },

        currentGroupBy (groupBy) {
            this.$emit('group-by-changed', groupBy);

            this.hideMenu();
        },

        currentColumnsToShow (currentColumnsToShow, oldCurrentColumnsToShow) {
            if (! currentColumnsToShow.length) {
                this.$notify({
                    type: 'warning',
                    text: 'You must select at least one column.',
                });

                this.currentColumnsToShow = oldCurrentColumnsToShow;
                return;
            }

            this.$emit('columns-to-show-changed', currentColumnsToShow);
        },

        currentSettings (settings) {
            this.$emit('settings-changed', settings);
        },
    },

    methods: {
        toggleMenu () {
            this.showMenu = ! this.showMenu;
        },
        hideMenu () {
            if (this.showMenu) {
                this.showMenu = false;
            }
        },
    },
};
</script>

<style>
.DatatableMenuOptions {
  display: block;
  padding-top: 0.25rem;
}
.DatatableMenuOptions--btn {
  font-size: 1.2rem;
  display: flex;
  cursor: pointer;
}
.DatatableMenuOptions--menu {
  display: flex;
  flex-direction: column;
  list-style: none !important;
  margin: 0.5rem 0 0 0;
  position: absolute;
  min-width: 200px;
  max-width: 300px;
  padding: 6px 16px;
  z-index: 1;
  background: #fff;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 3px 10px rgba(5, 51, 110, 0.3);
}
.DatatableMenuOptions--menu li {
  margin: 0;
  padding: 0.5rem 0;
}
.DatatableMenuOptions--menu label {
  margin: 0;
}
.DatatableMenuOptions--divider {
  font-size: 1px;
  border-top: solid 1px #e1e6ec;
  padding: 0 !important;
  margin: 0 !important;
}
.DatatableMenuOptions--checkbox {
  display: flex;
  align-items: center;
  margin: 0;
}
.DatatableMenuOptions--checkbox > input {
  margin: 0 0.5rem 0 0;
}
</style>
